var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconRotateRight = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(0.448 -2.17)" },
                React.createElement("path", { strokeDasharray: "4,4", d: "M4,19.3c0.7,3.3,3.1,5.9,6.3,7c5.1,1.8,10.6-0.9,12.4-5.9" })),
            React.createElement("g", { transform: "translate(0.448 -2.17)" },
                React.createElement("path", { d: "M18.9,15h6.5V8.5" }),
                React.createElement("path", { d: "M25.4,15l-5-4.7c-2.4-2.4-5.8-3.3-9.1-2.6C6.1,8.9,2.8,14.1,4,19.3" })))));
});
export default IconRotateRight;
//# sourceMappingURL=IconRotateRight.js.map